























































import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { EnumStorageType, StorageLib } from '@/libs/com/MetaPattern/Product/IDE/Util/StorageLib';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class MainNav extends Vue {
  handleSelect() {
    // handle select
  }

  get curUser() {
    return IDEContext.instance.curUser;
  }

  viewAccount() {
    EventBus.$emit('openPage', 'views/pages/AccountInfo.vue', 'AccountInfo', '账户信息', null);
  }

  logout() {
    IDEContext.instance.logout();
    StorageLib.instance.removeItem(EnumStorageType.Session, 'AccountInfo');
    this.$store.dispatch('User/setUserAction', null);
    this.$store.dispatch('User/setInitDoneAction', false);
    this.$router.push('/login');
  }

  /**
   * 下拉菜单命令处理
   * @param action 命令名称
   */
  menuCommand(command: string) {
    if (command === 'logout') {
      this.logout();
    } else if (command === 'userSelect') {
      IDEContext.instance.curUser = null;
      this.$store.dispatch('User/setInitDoneAction', false);
      this.$router.push('/UserSelect');
    } else if (command === 'viewAccount') {
      this.viewAccount();
    }
  }
}
